import { createModel } from "nyax";
import { DataTable, DataTableQuery } from "src/models/dataTable";
import { DataTableEntityModel } from "src/store/models/entity/dataTable/entity";
import { DataTableSideUIModel } from "src/store/models/ui/dataTable/dataTableSide";
import { createUITableWithPermissionModel } from "src/store/models/ui/_shared";

export type DataTableWithPermission = DataTable & {
  permissionValues: string[];
};

export const DataTableTableUIModel = createModel(
  class extends createUITableWithPermissionModel<DataTable, DataTableQuery>({
    setItems: (getContainer, items) =>
      getContainer(DataTableEntityModel).actions.setItems.dispatch(items),
    getItems: (getContainer) => getContainer(DataTableEntityModel).getters.items,
    getItem: (getContainer, id) =>
      getContainer(DataTableEntityModel).state.byId[id],
    getItemId: (item) => item.id,
  }) {
    public effects() {
      const superEffects = super.effects();
      return {
        ...superEffects,
        updateQuery: async (params: DataTableQuery) => {
          await superEffects.updateQuery(params);
          await this.getContainer(DataTableSideUIModel).actions.setQuery.dispatch(
            this.state.query
          );
        },
        initial: async (payload: { departmentId: string }) => {
          const { departmentId } = payload;
          this._initial({
            initialAction: (
              pageIndex: number,
              pageSize: number,
              query: DataTableQuery
            ) =>
              this.dependencies.serviceClient.dataTable.list(
                departmentId,
                pageIndex,
                pageSize,
                query
              ),
          });
        },
      };
    }
  }
);
